import React, { useEffect } from 'react';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import JDWPCHeader from '../../components/JDWHeader';
import JDWPCSearch from '../../components/JDWSearch';
import JDWPCNav from '../../components/JDWNav';
import JDWPCFooter from '../../components/JDWFooter';
import BreadCrumb from './component/breadCrumb';
import Selector from './component/selector';
import Recommend from './component/recommend';
import Filter from './component/filter';
import Pagination from './component/pagination';
import ProductsList from './component/productList';
import CompareCard from './component/compareCard';
import { getQuery } from '../../utils';
import { handleEv, handlePriceInListHTML } from '../../utils/ev';
import { dispatchCommonData } from '../../store/commonData/actionCreator';
import { dispatchMulBtnIdx, dispatchMulFilter, dispatchUrlParams, dispatchSearchProduct } from '../../store/search/actionCreator';
import { INDEX_FLOOR_ID } from '../../api/constant';
import styles from './index.module.scss';


// const handleEv = (ev) => {
//   if (!ev) return;
//   const obj = Object.create(null);
//   ev = ev[ev.length - 1] === '@' ? ev.slice(0, ev.length - 1) : ev;
//   const arr = ev.split('@');
//   const brandIndex = arr.findIndex(item => item.startsWith('exbrand'));
//   if (brandIndex !== -1) {
//     obj.brands = (arr.splice(brandIndex, 1)[0].replace(/exbrand_/, '').split('||'))
//   }
//   const priceIndex = arr.findIndex(item => item.startsWith('exprice'));
//   if (priceIndex !== -1) {
//     const priceArr = arr.splice(priceIndex, 1)[0].replace(/exprice_M/, '').split('L');
//     priceArr[0] && (obj.pM = priceArr[0]);
//     priceArr[1] && (obj.pL = priceArr[1]);
//   }
//   if (arr.length) {
//     obj.extAttrs = arr;
//   }
//   return obj
// }

const loadingIcon = <LoadingOutlined style={{ fontSize: 24, color: '#e2231a' }} spin />;

function Search() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search, pathname } = useLocation();
  const keyword = getQuery("keyword", history);

  const {
    isSku,
    searchLoading
  } = useSelector(state => state.searchReducer)

  useEffect(() => {
    let params = qs.parse(search, { sort: false });
    const _pathname = pathname.replace(/\//g,'');
    const evStr = params.ev;
    let _params;
    if (window.location.pathname.indexOf('list.html') !== -1) {
      _params = handlePriceInListHTML(evStr) || {};
      _params.channelType = "details";
    } else if (_pathname.toLowerCase() === 'search') {
      _params = handleEv(evStr);
      delete params.ev;
    }
    params = {
      ...params,
      ..._params
    }
    // dispatch(dispatchCrumb([]))
    dispatch(dispatchMulFilter(false))
    dispatch(dispatchMulBtnIdx(-1));
    dispatch(dispatchUrlParams(params))
    dispatch(dispatchSearchProduct(JSON.stringify(params)))
  }, [search, pathname])

  useEffect(() => {
    dispatch(dispatchCommonData(JSON.stringify({ applicationId: INDEX_FLOOR_ID })))
  }, [])

  if (isSku) {
    window.location.href = ("http://item.jd.com/" + keyword + ".html")
    return null;
  }

  return (
    <>
      <JDWPCHeader />
      <JDWPCSearch />
      <JDWPCNav />
      {
        searchLoading ? <div className='jdw-loading'>
          <Spin indicator={loadingIcon} />
        </div> :
          <>
            <BreadCrumb />
            <Selector />
            <div className='w'>
              <Recommend />
              <div className={styles["g-main1"]}>
                <div className={styles["m-list"]}>
                  <div className={styles["ml-wrap"]}>
                    <Filter />
                    <ProductsList />
                    <Pagination />
                  </div>
                </div>
              </div>
              <span className="clr"></span>
            </div>
            <CompareCard />
          </>
      }
      <JDWPCFooter />
    </>
  )
}

export default Search;